<template>
  <div class="capacity-report">
    <div class="capacity-report-name">能力分析报告</div>
    <div class="comparison">
      <div class="box">
        <!-- <p>{{familyName}}**能力雷达图</p> -->
        <p>对方的能力模型</p>
        <div class="chart-box">
          <div class="she chart" ></div>
          <div :class="['dot', `dot${item}`]" v-show="isSheShowDot" v-for="item in 5" :key="item + 'sheDot'"></div>
        </div>

      </div>
      <div class="box">
        <p>我的能力模型</p>
        <div class="chart-box">
          <div class="me chart"></div>
          <div :class="['dot', `dot${item}`]" v-show="isMeShowDot" v-for="item in 5" :key="item + 'meDot'"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  const chart = require('echarts');
  export default {
    name: "capacity-report",
    props: {
      meResult: {
        type: Object,
        default: () => {}
      },
      comparisonResult: {
        type: Object,
        default: () => {}
      },
      familyName: String
    },
    data(){
      return {
        isMeShowDot: false,
        isSheShowDot: false
      }
    },
    mounted() {
      this.eChartInit(document.querySelector(".she"), this.comparisonResult, 'she')
      this.eChartInit(document.querySelector(".me"),this.meResult, 'me')
    },
    methods:{
      eChartInit(dom, data, type){
        console.log(data)
        if(!data)return;
        delete data.skills
        // 基于准备好的dom，初始化echarts实例
        let myChart = chart.init(dom);
        // 绘制图表
        let option = {
          grid:{
            top: '50%',
            left:0,
            bottom:10,
            right:0,
          },
          radar: {
            indicator: [
              {text: '教育背景', max: 100,color:"#fff"},
              {text: '竞争力', max: 100,color:"#fff"},
              {text: '技能分析', max: 100,color:"#fff"},
              {text: '简历分析', max: 100,color:"#fff"},
              {text: '工作背景', max: 100,color:"#fff"},
            ],
            radius: ["0%", "65%"],
            splitNumber: 4,
            axisLine:{
              show: true,
              lineStyle:{
                color: 'rgba(255, 255, 255, 0.3)',
                width: 0.5
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.3)',
                width: 0.5
              }
            },
            textStyle:{
              rich:{

              }
            },
            splitArea:{
              show: false
            },
            
          },
          series: [
            {
              type: 'radar',
              itemStyle:{
                color:'rgba(255, 255, 255, 0.3)',
                opacity: 0
              },
              areaStyle:{
                color: type === 'she' ? '#fff' : "#ff6644"
              },
              data: [
                {
                  value: Object.values(data).map(num => num === 0 ? num + 10 : num).slice(3,8).reverse()
                }
              ]
            }
          ]
        }
        myChart.setOption(option);
        if(type == 'she'){
          this.isSheShowDot = true
        }else {
          this.isMeShowDot = true
        }
      }
    },
    watch:{
      meResult(value){
        if(!!value){
          this.eChartInit(document.querySelector(".me"),this.meResult, 'me')
        }
      },
      comparisonResult(value){
        if(!!value){
          this.eChartInit(document.querySelector(".she"), this.comparisonResult, 'she')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.capacity-report{
  margin-bottom: 50px;
  .capacity-report-name{
    font-size: 48px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 67px;
    margin-bottom: 30px;
  }
  .comparison{
    width: 1200px;
    height: 470px;
    box-shadow: 0px 2px 48px 0px rgba(25, 28, 36, 0.5);
    border-radius: 12px;
    background-size: 100%;
    background-image: url("https://files.wondercv.com/PC/editor/planning/people/bgcard1.png");
    padding: 32px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    & > .box{
      width: 552px;
      height: 406px;
      background: #252830;
      border-radius: 8px;
      padding: 30px 24px;
      box-sizing: border-box;
      & > p{
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 17px;
        margin-bottom: 20px;
      }
      .chart-box{
        position: relative;
        .dot{
          width: 8px;
          height: 8px;
          background: #282B32;
          border: 2px solid #F4F4F4;
          border-radius: 50%;
          position: absolute;
          z-index: 2;
          &.dot1{
            top: 45px;
            left:247px;
          }
          &.dot2{
            top: 112px;
            left: 152px;
          }
          &.dot3{
            top: 112px;
            left: 342px;
          }
          &.dot4{
            top: 224px;
            left: 189px;
          }
          &.dot5{
            top: 224px;
            left: 303px;
          }
        }
      }
      .chart{
        width: 100%;
        height: 300px;
        position: relative;
        z-index: 1;
      }
    }
  }
}
</style>
